import React from 'react';
import { usePaddle, useMountEffect } from '~/util';
import mParticle, { StartTrialPresentedEvent } from '~/Providers/mParticle';
import SubscriptionWithPaymentElement from './SubscriptionWithPaymentElement';
import PaddleSubscription from './PaddleSubscription';

const SubscriptionPage = () => {
  const usePaddleValue = usePaddle();
  console.log('SubscriptionPage', 'usePaddleValue', usePaddleValue);

  useMountEffect(() => {
    const platform = usePaddleValue ? 'paddle' : 'stripe';
    const event = new StartTrialPresentedEvent(platform);
    mParticle.logEvent(event);
  });

  return usePaddleValue ? <PaddleSubscription /> : <SubscriptionWithPaymentElement />;
};

export default SubscriptionPage;
